<div>
  <div class="splash-screen"
    [style]="{'opacity': opacityChange, 'transition': splashTransition,'display': splashdisplay}"
    >
    <img [attr.src]="loaderLogo" alt="Logo">
    <div class="spinner-border text-info" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</div>